<template>
  <section id="presse">
    <h1 class="no-pad" v-html="subpages.title"></h1>
    <curator :post="subpage" v-for="subpage in subpages.children" :key="subpage.uid">
    </curator>
  </section>
</template>

<script>
import Curator from '../components/Press.vue'

export default {
  name: 'curators',
  components: {
    Curator
  },
  computed: {
    subpages () {
      return this.$store.getters.getPageByUID('presse')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
</style>
